



































import ffButton from '@/components/public/Button.vue'
import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
  components: {
    ffButton
  }
})
export default class UploadItem extends Vue {
  @Prop({
    type: String,
    default: '',
    required: true
  })
  name!: string
  @Prop({
    type: Number,
    default: '',
    required: false
  })
  index!: number
  @Prop({
    type: String,
    default: '0%',
    required: true
  })
  progress!: string
  @Prop({
    type: Number,
    default: 0,
    required: false
  })
  status!: number
  @Prop({
    type: Number,
    default: 0,
    required: false
  })
  size!: number
  @Prop({
    type: Number,
    default: 0,
    required: false
  })
  time!: number
  @Prop({
    type: String,
    default: '',
    required: false
  })
  url!: string
  @Prop({
    type: Number,
    default: '',
    required: true
  })
  uid!: number

  classFormat (status: number): string {
    switch (status) {
      case 0:
      case 3:
        return 'waiting'
      default:
        return ''
    }
  }
  timeFormat (time: number): string {
    const date = new Date(time * 1000)
    const [secs, mins, hours, day, month, year ] = [
      date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds(),
      date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes(),
      date.getHours() < 10 ? '0' + date.getHours() : date.getHours(),
      date.getDate() < 10 ? '0' + date.getDate() : date.getDate(),
      date.getMonth() + 1 < 10 ? '0' + (date.getMonth()+1) : date.getMonth()+1,
      date.getFullYear()
    ]
    return `${year}.${month}.${day} ${hours}:${mins}:${secs}`
  }
  sizeFormat (size: number): string {
    return (size / 1024).toFixed(1) + 'KB'
  }
  onCopy () {
    this['$notify']({
      title: 'success',
      message: 'Copy success',
      type: 'success',
      offset: 80
    })
  }
  onError () {
    this['$notify'].error({
      title: 'Failed',
      message: `Copy failed`,
      offset: 80
    })
  }
  tryAgain () {
    this.$emit('try-upload', this.uid)
  }
}
